import UOM from '../../../../elements/Select/UOM'
import React from 'react'
import { Checkbox, Col, Form, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout, rules, threeFormItemLayout } from '../../../../modules/FormItems'
import InfoTooltip from '../../../../elements/InfoTooltip'
import MaterialDetails from '../../../../elements/MaterialDetails'

const { TextArea } = Input

function RFQLinesForm (props) {
  const { line } = props
  const { getFieldDecorator, resetFields, getFieldValue, setFieldsValue } = props.form
  return (
    <Form>
      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <h3 style={{ marginBottom: 0, color: 'rgb(43,187,143' }}>VENDOR ENQUIRY DETAILS</h3>
      </Row>
      <Row>
        <Col span={4}>
          <Form.Item
            {...threeFormItemLayout}
            style={{ width: '100%' }}
            label={<InfoTooltip value={'No'} title={'Use zero in front of numbers 0-9, ie: 01, 02'}/>}>
            {getFieldDecorator('no', {
              initialValue: get(line, 'no'),
              rules: rules.input,
            })(<Input placeholder={'Line No'}/>)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            {...threeFormItemLayout}
            style={{ width: '100%' }}
            label={<InfoTooltip value={'Vendor No'} title={'Enter Vendor Material No (Part No) if re-ordering'}/>}>
            {getFieldDecorator('vendorNo', {
              initialValue: get(line, 'vendorNo'),
            })(<Input placeholder={'Vendor Part No'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Item Name">
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.input,
            })(<Input placeholder={'Name'}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            {...{
              labelCol: {
                xs: { span: 24 },
                sm: { span: 2 },
                xxl: { span: 2 },
              },
              wrapperCol: {
                xs: { span: 24 },
                sm: { span: 22 },
                xxl: { span: 22 },
              },
            }}
            label={<InfoTooltip value={'Description'} title={'Please input specifications of the required Item.'}/>}>
            {getFieldDecorator('description', {
              initialValue: get(line, 'description'),
              rules: rules.input,
            })(<TextArea placeholder={'Please input specifications of the required Item.'}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Units (Qty)">
            {getFieldDecorator('unit', {
              initialValue: get(line, 'unit'),
              rules: rules.input,
            })(<InputNumber placeholder={'Units'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="UoM">
            {getFieldDecorator('uom.code', {
              initialValue: get(line, 'uom.code'),
              rules: rules.select,
            })(<UOM/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item style={{ width: '120%' }} {...threeFormItemLayout} label={'Nominated OEM: '}>
            {getFieldDecorator('nominatedOEM', {
              initialValue: get(line, 'nominatedOEM'),
              valuePropName: 'checked',
            })(<Checkbox/>)}
          </Form.Item>
        </Col>
      </Row>
      <MaterialDetails
        line={line}
        {...{
          getFieldDecorator,
          getFieldValue,
          setFieldsValue,
          resetFields,
          type: 'RFQ',
        }}
      />
    </Form>
  )
}

RFQLinesForm.propTypes = {}
RFQLinesForm.defaultProps = {}

export default Form.create()(RFQLinesForm)
